import React, { useState, useRef } from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select, { components } from "react-select";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import idly from '../../../../images/items/idly.png'; 

const UpdateRawMaterial = ({ show, onClose }) => {
    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
    const options_units = [
        { value: "1", label: "gms" },
        { value: "2", label: "Kg's" },
        { value: "3", label: "Ltr's" }, 
        { value: "4", label: "ton's" },
        { value: "5", label: "No's" },
    ];



    const [selectedOption, setSelectedOption] = useState(null);



    const [rawMatrial, setRawMatrial] = useState([{ id: Date.now() }]);
    // Add new IP configuration
    const handleAddConfig = () => {
        setRawMatrial([...rawMatrial, { id: Date.now() }]);
    };

    // Delete an IP configuration
    const handleDeleteConfig = (id) => {
        setRawMatrial(rawMatrial.filter(config => config.id !== id));
    };
    const rice_shop = [
        { value: "0", label: "Basmathi Rice" },
        { value: "1", label: "Ponni Rice" },
    ];
    const pulses = [
        { value: "0", label: "Urad Dal" },
        { value: "1", label: "Chana Dal" },
        { value: "2", label: "Fenugreek" },
    ];
    const salt = [
        { value: "0", label: "Rock Salt" },
        { value: "1", label: "Normal Salt" },
    ];
    const spices = [
        { value: "0", label: "Red Chilli Powder" },
        { value: "1", label: "Cumin Seed" },
    ];
    const oil = [
        { value: "0", label: "Refined Oil" },
        { value: "1", label: "Sunflower Oil" },
        { value: "2", label: "Refinded Coconut Oil" },
    ];
    const vegetable = [
        { value: "0", label: "Tomato" },
        { value: "1", label: "Brinjal" },
        { value: "2", label: "Potato" },
    ];

    const groupedOptions_raw_material = [
        {
            label: "Grains",
            options: rice_shop,
        },
        {
            label: "Pulses",
            options: pulses,
        },
        {
            label: "Seasonings",
            options: salt,
        },
        {
            label: "Whole Spices",
            options: spices,
        },

        {
            label: "Oil",
            options: oil,
        },

        {
            label: "Vegetables",
            options: vegetable,
        }

    ];
    const Group = (props) => (
        <div style={customStyles}>
            <components.Group {...props} />
        </div>
    );
    const customStyles = {
        groupHeading: (provided) => ({
            ...provided,
            fontSize: '14px',  // Increase the font size for group labels
            fontWeight: 'bold',  // Optional: make the label bold
            color: '#333',  // Optional: change the text color
        }),
    };
    const [isVisible, setIsVisible] = useState({
        receipe_notes: false,
    });
    const toggleDiv = (section) => {
        setIsVisible((prev) => ({
            ...prev,
            [section]: !prev[section],
        }));
    };
    const steamed = [
        { value: "0", label: "Idly" },
        { value: "1", label: "Puttu" },
    ];
    const rice = [
        { value: "0", label: "Dosai" },
        { value: "1", label: "Uthappam" },
    ];
    const groupedOptions_items = [
        {
            label: "Steamed Food",
            options: steamed,

        },
        {
            label: "Rice Based Food",
            options: rice,
        },
    ];
    return (
        <Modal show={show} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Needed Raw Material</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row mb-3">
                        <div className="col-lg-12">
                            <div className="d-flex align-items-center justify-content-start gap-2">
                                <LightGallery
                                    onInit={onInit}
                                    speed={500}
                                    plugins={[lgThumbnail, lgZoom]}
                                >
                                    <div data-src={idly} className='border rounded px-1 py-0'>
                                        <img src={idly} alt="Podi Idly" className='cursor-pointer w-60px h-60px' />
                                    </div>
                                </LightGallery>
                                <div className=''>
                                    <label className='text-black font-w400 fs-5'>Podi Idly</label>
                                    <label className='text-black me-2 ms-2'>|</label>
                                    <label className='text-black font-w400 fs-5'>Steamed Food</label>
                                    <label className='text-black me-2 ms-2'>|</label>
                                    <label className='text-black font-w400 fs-5'>Idly</label>
                                    <div className='d-block mt-1'>
                                        <label className='text-black font-w400 fs-7'>Quantity</label>
                                        <Badge bg="warning" className='text-white fs-7 py-0 px-1 ms-2 rounded-pill'>No's</Badge>
                                        <label className='text-black me-2 ms-2'>|</label>
                                        <label className='text-black font-w400 fs-7'>Weight</label>
                                        <Badge bg="success" className='text-white fs-7 py-0 px-1 ms-2 rounded-pill'>70 gms</Badge>
                                        <label className='text-black me-2 ms-2'>|</label>
                                        <label className='text-black font-w400 fs-7'>Size</label>
                                        <Badge bg="info" className='text-white fs-7 py-0 px-1 ms-2 rounded-pill'>9 cm</Badge>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='scroll-y mh-350px py-2'>
                            <div className="col-lg-12">
                                <div className="mb-0">
                                    {rawMatrial.map(config => (
                                        <div key={config.id} data-repeater-item>
                                            <div className="row">
                                                <div className="col-lg-7 mb-4">
                                                    <label className="text-black font-w500 fs-7">Raw Material<span className="required">*</span></label>
                                                    <Select
                                                        placeholder="Select Raw Material"
                                                        defaultValue={rice_shop[1]}
                                                        options={groupedOptions_raw_material}
                                                        components={{ Group }}
                                                        styles={{
                                                            ...customStyles,
                                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        }}
                                                        menuPortalTarget={document.body}
                                                        menuPosition="fixed"
                                                    />
                                                </div>
                                                <div className='col-lg-2'>
                                                    <label className="text-black font-w500 fs-7">Quantity <span className="required">*</span></label>
                                                    <input type="text" className="form-control" placeholder="Enter Qty" defaultValue={'500'} />
                                                </div>
                                                <div className='col-lg-2'>
                                                    <label className="text-black font-w500 fs-7">Units<span className="required">*</span></label>
                                                    <Select
                                                        placeholder='Units'
                                                        defaultValue={options_units[0]}
                                                        onChange={setSelectedOption}
                                                        options={options_units}
                                                        menuPlacement='top'
                                                        menuPosition='fixed'
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            ...customStyles,
                                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        }}
                                                    />

                                                </div>
                                                <div className="col-lg-1 mb-1 px-1 py-1">
                                                    {/* {rawMatrial.length > 1 && ( */}
                                                    <button
                                                        className="btn btn-danger mt-4 px-2 py-2"
                                                        onClick={() => handleDeleteConfig(config.id)}
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        title="Delete"
                                                    >
                                                        <i className="fa-solid fa-trash-can fs-6 mt-1 text-white"></i>
                                                    </button>
                                                    {/* )} */}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-lg-7 mb-4">
                                                    <label className="text-black font-w500 fs-7">Raw Material<span className="required">*</span></label>
                                                    <Select
                                                        placeholder="Select Raw Material"
                                                        defaultValue={pulses[0]}
                                                        options={groupedOptions_raw_material}
                                                        components={{ Group }}
                                                        styles={{
                                                            ...customStyles,
                                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        }}
                                                        menuPortalTarget={document.body}
                                                        menuPosition="fixed"
                                                    />
                                                </div>
                                                <div className='col-lg-2'>
                                                    <label className="text-black font-w500 fs-7">Quantity <span className="required">*</span></label>
                                                    <input type="text" className="form-control" placeholder="Enter Qty" defaultValue={'500'} />
                                                </div>
                                                <div className='col-lg-2'>
                                                    <label className="text-black font-w500 fs-7">Units<span className="required">*</span></label>
                                                    <Select
                                                        placeholder='Units'
                                                        defaultValue={options_units[0]}
                                                        onChange={setSelectedOption}
                                                        options={options_units}
                                                        menuPlacement='top'
                                                        menuPosition='fixed'
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            ...customStyles,
                                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        }}
                                                    />

                                                </div>
                                                <div className="col-lg-1 mb-1 px-1 py-1">
                                                    {/* {rawMatrial.length > 1 && ( */}
                                                    <button
                                                        className="btn btn-danger mt-4 px-2 py-2"
                                                        onClick={() => handleDeleteConfig(config.id)}
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        title="Delete"
                                                    >
                                                        <i className="fa-solid fa-trash-can fs-6 mt-1 text-white"></i>
                                                    </button>
                                                    {/* )} */}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-lg-7 mb-4">
                                                    <label className="text-black font-w500 fs-7">Raw Material<span className="required">*</span></label>
                                                    <Select
                                                        placeholder="Select Raw Material"
                                                        defaultValue={pulses[2]}
                                                        options={groupedOptions_raw_material}
                                                        components={{ Group }}
                                                        styles={{
                                                            ...customStyles,
                                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        }}
                                                        menuPortalTarget={document.body}
                                                        menuPosition="fixed"
                                                    />
                                                </div>
                                                <div className='col-lg-2'>
                                                    <label className="text-black font-w500 fs-7">Quantity <span className="required">*</span></label>
                                                    <input type="text" className="form-control" placeholder="Enter Qty" defaultValue={10} />
                                                </div>
                                                <div className='col-lg-2'>
                                                    <label className="text-black font-w500 fs-7">Units<span className="required">*</span></label>
                                                    <Select
                                                        placeholder='Units'
                                                        defaultValue={options_units[0]}
                                                        onChange={setSelectedOption}
                                                        options={options_units}
                                                        menuPlacement='top'
                                                        menuPosition='fixed'
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            ...customStyles,
                                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        }}
                                                    />

                                                </div>
                                                <div className="col-lg-1 mb-1 px-1 py-1">
                                                    {/* {rawMatrial.length > 1 && ( */}
                                                    <button
                                                        className="btn btn-danger mt-4 px-2 py-2"
                                                        onClick={() => handleDeleteConfig(config.id)}
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        title="Delete"
                                                    >
                                                        <i className="fa-solid fa-trash-can fs-6 mt-1 text-white"></i>
                                                    </button>
                                                    {/* )} */}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-lg-7 mb-4">
                                                    <label className="text-black font-w500 fs-7">Raw Material<span className="required">*</span></label>
                                                    <Select
                                                        placeholder="Select Raw Material"
                                                        defaultValue={salt[1]}
                                                        options={groupedOptions_raw_material}
                                                        components={{ Group }}
                                                        styles={{
                                                            ...customStyles,
                                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        }}
                                                        menuPortalTarget={document.body}
                                                        menuPosition="fixed"
                                                    />
                                                </div>
                                                <div className='col-lg-2'>
                                                    <label className="text-black font-w500 fs-7">Quantity <span className="required">*</span></label>
                                                    <input type="text" className="form-control" placeholder="Enter Qty" defaultValue={'15'} />
                                                </div>
                                                <div className='col-lg-2'>
                                                    <label className="text-black font-w500 fs-7">Units<span className="required">*</span></label>
                                                    <Select
                                                        placeholder='Units'
                                                        defaultValue={options_units[1]}
                                                        onChange={setSelectedOption}
                                                        options={options_units}
                                                        menuPlacement='top'
                                                        menuPosition='fixed'
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            ...customStyles,
                                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        }}
                                                    />

                                                </div>
                                                <div className="col-lg-1 mb-1 px-1 py-1">
                                                    {/* {rawMatrial.length > 1 && ( */}
                                                    <button
                                                        className="btn btn-danger mt-4 px-2 py-2"
                                                        onClick={() => handleDeleteConfig(config.id)}
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        title="Delete"
                                                    >
                                                        <i className="fa-solid fa-trash-can fs-6 mt-1 text-white"></i>
                                                    </button>
                                                    {/* )} */}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-lg-7 mb-4">
                                                    <label className="text-black font-w500 fs-7">Raw Material<span className="required">*</span></label>
                                                    <Select
                                                        placeholder="Select Raw Material"
                                                        defaultValue={spices[1]}
                                                        options={groupedOptions_raw_material}
                                                        components={{ Group }}
                                                        styles={{
                                                            ...customStyles,
                                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        }}
                                                        menuPortalTarget={document.body}
                                                        menuPosition="fixed"
                                                    />
                                                </div>
                                                <div className='col-lg-2'>
                                                    <label className="text-black font-w500 fs-7">Quantity <span className="required">*</span></label>
                                                    <input type="text" className="form-control" placeholder="Enter Qty" defaultValue={20} />
                                                </div>
                                                <div className='col-lg-2'>
                                                    <label className="text-black font-w500 fs-7">Units<span className="required">*</span></label>
                                                    <Select
                                                        placeholder='Units'
                                                        defaultValue={options_units[0]}
                                                        onChange={setSelectedOption}
                                                        options={options_units}
                                                        menuPlacement='top'
                                                        menuPosition='fixed'
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            ...customStyles,
                                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        }}
                                                    />

                                                </div>
                                                <div className="col-lg-1 mb-1 px-1 py-1">
                                                    {/* {rawMatrial.length > 1 && ( */}
                                                    <button
                                                        className="btn btn-danger mt-4 px-2 py-2"
                                                        onClick={() => handleDeleteConfig(config.id)}
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        title="Delete"
                                                    >
                                                        <i className="fa-solid fa-trash-can fs-6 mt-1 text-white"></i>
                                                    </button>
                                                    {/* )} */}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-lg-7 mb-4">
                                                    <label className="text-black font-w500 fs-7">Raw Material<span className="required">*</span></label>
                                                    <Select
                                                        placeholder="Select Raw Material"
                                                        defaultValue={oil[2]}
                                                        options={groupedOptions_raw_material}
                                                        components={{ Group }}
                                                        styles={{
                                                            ...customStyles,
                                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        }}
                                                        menuPortalTarget={document.body}
                                                        menuPosition="fixed"
                                                    />
                                                </div>
                                                <div className='col-lg-2'>
                                                    <label className="text-black font-w500 fs-7">Quantity <span className="required">*</span></label>
                                                    <input type="text" className="form-control" placeholder="Enter Qty" defaultValue={'20'} />
                                                </div>
                                                <div className='col-lg-2'>
                                                    <label className="text-black font-w500 fs-7">Units<span className="required">*</span></label>
                                                    <Select
                                                        placeholder='Units'
                                                        defaultValue={options_units[0]}
                                                        onChange={setSelectedOption}
                                                        options={options_units}
                                                        menuPlacement='top'
                                                        menuPosition='fixed'
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            ...customStyles,
                                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        }}
                                                    />

                                                </div>
                                                <div className="col-lg-1 mb-1 px-1 py-1">
                                                    {/* {rawMatrial.length > 1 && ( */}
                                                    <button
                                                        className="btn btn-danger mt-4 px-2 py-2"
                                                        onClick={() => handleDeleteConfig(config.id)}
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        title="Delete"
                                                    >
                                                        <i className="fa-solid fa-trash-can fs-6 mt-1 text-white"></i>
                                                    </button>
                                                    {/* )} */}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                        </div>
                        <div className="mb-1 mt-1">
                            <button
                                className="btn btn-sm btn-primary"
                                onClick={handleAddConfig}
                            >
                                <span><i className="fa-solid fa-plus fs-6"></i></span>
                                <span className='ms-2 fs-7'>Add More</span>
                            </button>
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4">
                        <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link>
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={onClose}>Update Needed Raw Material</Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default UpdateRawMaterial;
